import {
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode, useRef, useState } from "react";
import { Select } from "antd";
import { Styles } from "./Style";
import { getOptionsFormAppPart } from "@lhd/components/CloneApp/fieldUtils";
import { CellCustomType } from "../../type";
import type { RefSelectProps } from "antd/es/select";

const DropdownRender = (props: {
  cell: Compatible<CellCustomType>;
  onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void;
  getCompatibleCell: (
    cell: Compatible<CellCustomType>,
  ) => Compatible<CellCustomType>;
}) => {
  const { cell, onCellChanged, getCompatibleCell } = props;
  const options = getOptionsFormAppPart(cell.appPart);
  const [open, setOpen] = useState(false);
  const selectRef = useRef<RefSelectProps>(null);
  return (
    <Styles
      onClick={(e) => {
        e.preventDefault();
        selectRef.current?.focus();
      }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <Select
        bordered={false}
        allowClear
        value={cell.valueSubmit as string}
        filterOption={(input, option: any) =>
          option.label.includes(input.trim())
        }
        ref={selectRef}
        open={open}
        onDropdownVisibleChange={(open) => {
          setOpen(open);
        }}
        onFocus={() => {
          setOpen(true);
        }}
        onBlur={() => {
          setOpen(false);
        }}
        onChange={(value) => {
          const updatedCell = getCompatibleCell({
            ...cell,
            text: value || "",
            valueSubmit: value || "",
          });

          onCellChanged(updatedCell, true);
          setOpen(false);
        }}
        options={options}
      />
    </Styles>
  );
};
export class DropDownCellTemplate implements CellTemplate<CellCustomType> {
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;

    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({
      ...cell,
      text: cellToMerge.text,
      valueSubmit: cellToMerge.valueSubmit,
    });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }
  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    return (
      <DropdownRender
        cell={cell}
        onCellChanged={onCellChanged}
        getCompatibleCell={this.getCompatibleCell}
      />
    );
  }
}
